import { ReactComponent as CheckOutlineIcon } from '../../../assets/icons/check-outline.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/error-outline.svg';
import Skeleton from 'react-loading-skeleton';
import './transactions-page.part.data-item.scss';

interface TransactionsPartDataItemProps {
  theme: 'success' | 'error';
  total: number;
  noTransactions: number;
  rate: number;
  isLoading: boolean;
}

const TransactionsPartDataItem: React.FC<TransactionsPartDataItemProps> = ({
  theme,
  total,
  noTransactions,
  rate,
  isLoading = false,
}) => {
    const highlightColor = theme === 'success' ? 'rgba(0, 182, 155, 0.5)' : 'rgba(236, 34, 31, 0.5)';
  return (
    <div className={`transactions-part-data-item ${theme} flex-column flex-gap-5 flex-1`}>
      <div className="icon">
        {theme === 'success' ? <CheckOutlineIcon /> : <ErrorIcon />}
      </div>

      <div className={`description ${theme}`}>
        {theme === 'success' ? 'Total Successful Amount:' : 'Total Failed Amount:'}{' '}
        <span className="value">
          {isLoading ? <Skeleton width={50}  highlightColor={highlightColor}/> : `$${total?.toLocaleString(undefined, { minimumFractionDigits: 2 })}`}
        </span>
      </div>

      <div className={`description ${theme}`}>
        {theme === 'success' ? 'Number of Successful Transactions:' : 'Number of Failed Transactions:'}{' '}
        <span className="value">
          {isLoading ? <Skeleton width={60}  highlightColor={highlightColor} /> : noTransactions}
        </span>
      </div>

      <div className={`description ${theme}`}>
        {theme === 'success' ? 'Transaction Success Rate:' : 'Transaction Fail Rate:'}{' '}
        <span className="value">
          {isLoading ? <Skeleton width={50}  highlightColor={highlightColor} /> : `${rate?.toLocaleString(undefined, { minimumFractionDigits: 2 })}%`}
        </span>
      </div>
    </div>
  );
};

export default TransactionsPartDataItem;
